module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BlackItalic.d9c1fff5.woff2";